import { useSelector } from 'react-redux';
import { selectCurrUserPermission } from '@/store/bootstrap/selectors';

/**
 * Permission helpers.
 *
 * Relocated here from `@/ui/permission` so lower layers (other hooks) can use
 * `usePermission` without importing into the components layer. `@/ui/permission`
 * re-exports these for its many within-UI callers (PermissionGuard/PageGuard).
 *
 * Returns `true` if `permissions` satisfies the permission `spec`.
 *   checkPermissions(permissions, 'some.action?')
 *   checkPermissions(permissions, { all: [...] })   // all must pass
 *   checkPermissions(permissions, { any: [...] })   // at least one must pass
 */
export function checkPermissions(permissions = {}, spec) {
  if (typeof spec === 'string') {
    return permissions[spec];
  }
  const { any, all } = spec;
  return (
    (any ? any.some((perm) => permissions[perm]) : true) &&
    (all ? all.every((perm) => permissions[perm]) : true)
  );
}

export const usePermission = ({ permission = null }) => {
  const permissions = useSelector(selectCurrUserPermission);
  if (!permission) {
    console.warn('permission property is needed for PermissionGuard');
    return null;
  }
  return checkPermissions(permissions, permission);
};
